import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import AuthUser from '../auth/AuthUser';
import {Link, NavLink} from 'react-router-dom';
import Login from '../auth/Login';
import './include.css';


function Sidebar()
{

		 // create variable for navigate the url
		 const navigate = useNavigate();
		 // function for logout 
			 const logout = () => {
				 // alert("kk");
				 if(!user_local_token)
				 {
					 navigate('/');
				 }
				 else{
					 localStorage.clear();
					 navigate('/')
				 }                 
				  
			 }

			 let user_local_token = localStorage.getItem('token');
			 var RoleId = localStorage.getItem('role_id');
	
    return (
        <nav id="sidebar" className="sidebar js-sidebar" >
			<div className="sidebar-content js-simplebar"  >
				<a className="sidebar-brand" style={{textDecoration:'none'}}>
					<span className=" castor_sidebar_head sidebar_link_castor">CASTOR</span>
					
				</a>
				<ul className="sidebar-nav">
					{/* <li className="sidebar-header">
						Pages
					</li> */}
					<span>
						{RoleId==2 ? 
					<li className="sidebar-item ">
						<span className="align-middle"> 
						<NavLink to="/farmer_profile" activeClassName={"active"} style={{textDecoration:'none'}} >
							<img src="/images/png/icon-proflie-100.png" className="img-fluid sidebar_icon" alt="image"/>
							<strong className='sidebar_link'>Profile</strong>
							</NavLink>
						</span>            
					</li>
					: ''}
					</span>
					<span>
						{RoleId==2 ? <li className="sidebar-item ">
						<span className="align-middle" > 
						<NavLink to="/overview" activeClassName={"active"} style={{textDecoration:'none'}} >
							<img src="/images/png/icon-dashboard-100.png" className="img-fluid sidebar_icon" alt="image"/>
							<strong className='sidebar_link'>Overview</strong>
							</NavLink>
						</span>
            
					</li> : ''}
					</span>
					<span>
						{RoleId==2 ? <li className="sidebar-item ">
						<span className="align-middle">
							<NavLink to="/irrigation" activeClassName={'active'} style={{textDecoration:'none'}}>
						<img src="/images/png/icon-irrigation-100.png" className="img-fluid sidebar_icon" alt="image"/>								
								<strong className='sidebar_link'>Irrigation</strong>
							</NavLink>
							</span>
          
					</li> : ''}
					</span>
					<span>
						{RoleId==2 ? <li className="sidebar-item ">
						<span className="align-middle">
						  <Link to="/input" className=''style={{textDecoration:'none'}}>
						<img src="/images/png/icon-input-100.png" className="img-fluid sidebar_icon " alt="image"/> 
							<strong className='sidebar_link'>Input</strong>
						  </Link>
							</span>
					
					</li> : ''}
					</span>
					{RoleId==2 ? <li className="sidebar-item ">
				 		<span className="align-middle">
						<Link to="/mill_list" className='' style={{textDecoration:'none'}}>
						{/* <img src="/images/pesticide.png" className="img-fluid sidebar_icon" alt="image"/>  */}
						{/* <strong className='sidebar_link'>Mill_List</strong> */}
						</Link>
						</span>
           
					</li> : ''}
					<span>
						{RoleId==2 ? <li className="sidebar-item ">
						<span className="align-middle">
						<Link to="/yield" className='' style={{textDecoration:'none'}}>
						<img src="/images/png/icon-yield-100.png" className="img-fluid sidebar_icon" alt="image"/> 
						<strong className='sidebar_link'>Yield</strong>
						</Link>
						</span>
           
					</li> : ''}
					</span>
					<span>
						{RoleId==2 ? <li className="sidebar-item ">
						<span className="align-middle">
						<Link to="/demo-plot" className='' style={{textDecoration:'none'}}>
						<span className='spanItem'>
						<img src="/images/png/icon-demo-plot-100.png" className="img-fluid sidebar_icon" alt="image"/> 
						<strong className='sidebar_link'>DemoPlot</strong>
						</span>
						</Link>
						</span>
           
					</li> : ''}
					</span>
					<span>
						{RoleId==2 ? <li className="sidebar-item ">
						<span className="align-middle">
						<Link to="/mill_list" className='' style={{textDecoration:'none'}}>
						<span className='spanItem'>
						<img src="/images/png/mill_icon.png" className="img-fluid sidebar_icon" alt="image"/> 
						<strong className='sidebar_link'>Mills</strong>
						</span>
						</Link>
						</span>
           
					</li> : ''}
					</span>
					<span>
						{/* {RoleId==2 ? 
					<a href="http://castor_analytics.solidaridadasia.com/api/graph/" target="_blank" rel="noreferrer" className='btn btn-secondary analytics'>Analytics Dashboard</a>
					 : ''} */}
					</span>
					<li className="sidebar-item ">
						<span className="align-middle">
						<a type="button" className="dropdown-item logout mt-4 " onClick={logout}>
						{/* <img src="/images/logout.png" className="img-fluid sidebar_icon" alt="image"/>  */}
						<span className='span'><strong className='logoutbutton'>Log out</strong></span>
						</a>					
						</span>
					          
					</li>
					
			</ul>			
			</div>
		</nav>
    )
}
export default Sidebar;